import React from "react";
import bannerSvg1 from "../../../assets/images/bannerTopRight.jpg";
import bannerSemi1 from "../../../assets/images/bannerLeftSemi.jpg";

import bannerBg from "../../../assets/images/bgBanner.svg";
import mobileBg from "../../../assets/images/mobileBg.svg";
import domainUpdate from "../../../assets/images/domainUpdate.png";
import landscapes from "../../../assets/images/PAN-pop-up_1418x722.jpg";
// import landscapes from "../../../assets/images/PAN New Form Poster_v2.jpg";
import "../../../Styles/Ticker.css"


export default function FirstSection() {
  // const handleImageClick = () => {
  //   const urls = [
  //     'https://tinpan.proteantech.in/downloads/ENGLISH Form 49A on 17-03-2026.pdf',
  //     'https://tinpan.proteantech.in/downloads/ENGLISH Form 49AA on 17-03-2026.pdf',
  //     'https://tinpan.proteantech.in/downloads/Hindi Form 49A on 18-03-2026.pdf',
  //     'https://tinpan.proteantech.in/downloads/Hindi Form 49AA on 18-03-2026.pdf',
  //     'https://tinpan.proteantech.in/downloads/Hindi Form 49B on 18-03-2026.pdf'
  //   ];

  //   urls.forEach((url, index) => {
  //     setTimeout(() => {
  //       window.open(url, `_blank_${index}`);
  //     }, index * 200); // 200ms delay between each tab
  //   });
  // };
  return (
    <section className="w-full flex flex-col py-10 justify-center items-center md:py-6 relative">
      <div className="absolute bottom-[-1rem] md:bottom-[0px] left-[45%] z-40">
        <a href="/#SecondSection" className="scroll-smooth">
          <svg
            width="66"
            height="67"
            viewBox="0 0 66 67"
            fill="none"
            xmlns="http://.w3.org/2000/svg"
          >
            <path
              d="M50.3333 41.3335L35.3817 50.3045C34.326 50.9379 33.0073 50.9379 31.9517 50.3045L17 41.3335"
              stroke="black"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M50.3333 28L35.3817 36.971C34.326 37.6044 33.0073 37.6044 31.9517 36.971L17 28"
              stroke="black"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      </div>
      <div className="absolute right-0 top-0">
        <img
          src={bannerSvg1}
          className="lg:w-[177px] w-[50px] z-10"
          alt="protean"
        />
      </div>
      <div className="absolute left-0 top-[40%] hidden lg:block">
        <img src={bannerSemi1} className="w-[60px] h-[201px]" alt="protean" />
      </div>

      <div className="w-full justify-center items-center flex flex-col z-20 relative">
        <div className="ticker-container">
          <div className="ticker-text">
            <i>
              {/* 1. As per the revised Income-tax Rules, 2026, w.e.f. April 1, 2026, Aadhaar will NOT be accepted as Proof of Date of Birth along with PAN application. PAN applicants are required to submit Proof of Date of Birth (other than Aadhaar) while applying for PAN. */}
              {/* 1. Explore RPU Version 1.0 (Preview), applicable for filing returns for Tax Year 2026-27 (earlier Financial Year) onwards. This beta version is for review only and should not be used for actual TDS/TCS filing. <a href="https://tinpan.proteantech.in/downloads/TDS_RPU_1.1.zip">Click here to download the beta version. </a>  */}
              {/* 1. Scheduled Downtime - PAN, TIN and OPV services will be unavailable on 16th August 2026 from 12:00 AM to 8:00 AM due to scheduled maintenance. */}
              {/* 1. Address Update facility through Aadhaar based e-KYC is available free of cost on Protean Portal. */}
              {/* 1.Address Update facility including updation of Mobile number and email ID through Aadhaar based e-KYC is available free of cost on Protean Portal */}
              1. As per provisions of Section 467 of Income Tax Act, 2025, a penalty of Rs. 10,000 can be levied on possession of more than one PAN.
            </i>
          </div>
        </div>
        <div className="ticker-container">
          <div className="ticker-text ticker-text-catchy">
            <i>
              {/* 1. Important notice for PAN applicants: If PAN applicant has not submitted correct Date of Birth (DOB) proof, the application will be rejected. Applicant can refer Rule 158 of Income Tax Act, 2025 (<a href="https://www.incometaxindia.gov.in/w/rule-158-1" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline', color: 'inherit' }}>https://www.incometaxindia.gov.in/w/rule-158-1</a>) for the list of documents for DOB proof. Aadhaar is not a valid proof for DOB.{" "} */}
              1. All stakeholders are advised to use the latest versions of RPU and FVU Version 1.2 for filing Regular and Correction of TDS/TCS statements to ensure compliance with the provisions of the New Income Tax Act, 2025
            </i>
          </div>
        </div>
        {/* <div className="ticker-container">
          <div className="ticker-text ticker-text-catchy">
            <i>
              <b>Applicants are requested to take note that this portal is under scheduled maintenance. Services shall resume shortly. Inconvenience caused is regretted.</b>
            </i>
          </div>
        </div> */}
        <p> <b>We have Upgraded!</b></p>
        <p className="font-semibold px-10 lg:px-0 text-center text-[16px] text-[#E43625]">
          Welcome to the new look of the PAN Services Page.
        </p>
      </div>
      <div className="block lg:hidden py-[12px]">
        <img src={mobileBg} alt="protean" />
        <div className="px-[20px] py-[12px] flex flex-col gap-[30px]">
          <h1 className="lg:text-h1-lg text-h1-mobile max-w-[80%] font-semibold">
            Get your PAN in just four simple steps!
          </h1>

          <a
            href="https://tinpan.proteantech.in/services/pan/pan-index.html"
            className="py-[12px] text-base font-medium text-white max-w-[50%] flex items-center justify-between  px-[24px] rounded-[8px] text-center"
          >
            Apply now
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_2429_15128)">
                <path
                  d="M5 12H19"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15 16L19 12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15 8L19 12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_2429_15128">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>

        </div>
      </div>
      <div
        className="hidden img-cont min-h-[500px] min-w-full lg:flex flex-col justify-center"
        style={{
          backgroundImage: `url(${bannerBg})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
        }}
      >
        <img
          src={landscapes}
          className="lg:w-[500px] w-[250px] h-auto object-contain z-10 ml-14"
          alt="landscapes"
        />

        {/* <div onClick={handleImageClick}>
          <img
            src={landscapes}
            className="lg:w-[300px] w-[250px] lg:h-[400px] h-400px object-contain z-10 ml-14"
            alt="landscapes"
            style={{ cursor: 'pointer' }} 
          />
        </div> */}

        <div className="flex flex-col lg:max-w-[700px] px-[70px] items-start gap-6">
          <h1 className="text-[45px] font-semibold">
            Get your PAN in just four simple steps!
          </h1>
          <a
            href="https://onlineservices.proteantech.in/paam/endUserRegisterContact.html"
            type="button"
            className="py-[12px] text-base font-medium text-white min-w-[200px] flex items-center justify-between bg-black px-[24px] rounded-[8px] text-center"
          >
            Apply now
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >

              <g clipPath="url(#clip0_2429_15128)">
                <path
                  d="M5 12H19"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15 16L19 12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15 8L19 12"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_2429_15128">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>


        </div>

      </div>
    </section>

  );
}
